module.exports = __webpack_public_path__ + "img/top-10-main.1ba580fe.webp";